import React from 'react';
import './App.scss';
import 'common.ui/dist/index.css';
import { MsalProvider } from 'auth/MsalContext';
import ReactNotification, { store } from 'react-notifications-component';
import { RegisterErrorCallback, RegisterError } from 'helpers/errorHandling/ErrorHandling';
import Routes from './Routing';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from 'ApplicationInsightsService';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// Configure QueryClient with best practices
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000 // 5 minutes
    }
  }
});

class App extends React.Component {
  componentDidMount() {
    RegisterErrorCallback((err) => {
      store.addNotification({
        message: err,
        type: 'danger',
        insert: 'top',
        container: 'top-right',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
          duration: 10000
        }
      });
    });
    window.onerror = (err: Event | string) => {
      RegisterError(err);
    };
  }

  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <AppInsightsContext.Provider value={reactPlugin}>
            <MsalProvider>
              <ReactNotification />
              <Routes />
            </MsalProvider>
          </AppInsightsContext.Provider>
        </HelmetProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    );
  }
}

export default App;
